const useFaqAccordion = () => {
  const slideSpeed = 400

  $('section.faq').on('click', '[data-type="accordion"]', function (e) {
    const target = $(e.target)
    const isClickHead = target.hasClass('.faq-article_head') || target.closest('.faq-article_head').length

    if (isClickHead) {
      const item = target.closest('.faq-article_item')
      const body = item.find('.faq-article_body')
      const isActive = item.hasClass('is-active')
      if (isActive) {
        item.removeClass('is-active')
        body.slideUp(slideSpeed)
      }
      if (!isActive) {
        item.addClass('is-active').siblings().removeClass('is-active').find('.faq-article_body').slideUp(slideSpeed)
        body.slideDown(slideSpeed)
      }
    }
  })
}


export {
  useFaqAccordion
}